import {
  Box,
  Button,
  Divider,
  FormControl,
  FormHelperText,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import MarketingGeniusButton from "./MarketingGeniusButton";
import { useDarkMode } from "../../../contexts/useDarkModeContext";
const popularSearchButtons = [
  { text: "Graphic Designer" },
  { text: "UI/UX" },
  { text: "Web Developer" },
  { text: "Copywiter" },
  { text: "Front-End Developer" },
];
function EmpowerYourCareerSection() {
  const { darkMode } = useDarkMode();
  return (
    <Stack
      direction="row"
      sx={{
        // border: "1px solid black",
        mx: "90px",
        my: "120px",
        mb: "100px",
        position: "relative",
      }}
    >
      <Stack sx={{ width: "65%" }}>
        <Typography
          variant="body2"
          sx={{
            fontWeight: "500",
            fontSize: "16px",
            lineHeight: "22px",
            fontFamily: "Inter",
            color: darkMode ? "#ffffff" : "#000000",
          }}
        >
          Explore Best Job Opportunities
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontWeight: "700",
            fontSize: "86px",
            lineHeight: "96px",
            maxWidth: "558px",
            fontFamily: "Inter",
            color: darkMode ? "#ffffff" : "#0E0B33",
            py: "6px",
          }}
        >
          Empower Your Career
        </Typography>
        <Typography
          variant="body2"
          sx={{
            fontWeight: "500",
            fontSize: "16px",
            lineHeight: "22px",
            fontFamily: "Inter",
            color: darkMode ? "#c6c6c6" : "#4a4866",
            maxWidth: "490px",
          }}
        >
          Discover your next career move with JobLinkup, the go-to job
          marketplace for job seekers and employers.
        </Typography>
        <TextField
          variant="outlined"
          placeholder="What job are you looking for?"
          sx={{
            input: {
              bgcolor: "#ffffff",
              color: "#4a4866",
              fontSize: "16px",
              lineHeight: "22px",
              fontWeight: "400",
              boxSizing: "content-box",
              px: "0px",
              py: "20px",
              "&::placeholder": {
                color: "#4a4866",
                opacity: 1,
              },
            },
            "& .MuiOutlinedInput-root": {
              px: "8px",
              borderRadius: "59px",
              bgcolor: "#FFFFFF",
              "& fieldset": {
                border: "1px solid #E3E3E3",
                borderRadius: "59px",
              }, // Outline color
              "&:hover fieldset": {
                border: "1px solid #E3E3E3",
                borderRadius: "59px",
              }, // Hover state
              "&.Mui-focused fieldset": {
                border: "1px solid #E3E3E3",
                borderRadius: "59px",
              }, // Focus state
            },
            mt: "30px",
            mb: "12px",
            zIndex: 1,
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment sx={{ px: "16px" }} position="top">
                <Box component="img" src="/icons/searchIcon.svg"></Box>
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <Stack
                  direction="row"
                  sx={{
                    alignItems: "center",
                    gap: "20px",
                    alignItems: "center",
                  }}
                >
                  <Divider
                    orientation="vertical"
                    sx={{ border: "1px solid #0E0B33", height: "36px" }}
                  />
                  <FormControl
                    variant="standard"
                    sx={{
                      minWidth: 250,
                      "& .MuiInputBase-root::before": {
                        borderBottom: "none !important",
                      }, // Removes bottom border
                      "& .MuiInputBase-root::after": {
                        borderBottom: "none !important",
                      }, // Removes focus border
                      "& .MuiInputBase-root:hover:not(.Mui-disabled)::before": {
                        borderBottom: "none !important",
                      }, // Removes hover border
                      "& .MuiSelect-select": {
                        backgroundColor: "transparent",
                        color: "#4a4866",
                        fontFamily: "Inter",
                      }, // Keeps background clean
                      "& .MuiSelect-select.Mui-selected": {
                        color: "#4a4866",
                        fontFamily: "Inter",
                        backgroundColor: "#FFD700 !important", // Custom highlight color when selected
                      },
                      "& .MuiOutlinedInput-notchedOutline": { border: "none" }, // Ensures no outline
                    }}
                  >
                    <Select
                      id="demo-simple-select-helper"
                      displayEmpty
                      defaultValue="" // Ensures placeholder is shown initially
                      IconComponent={() => (
                        <Box
                          component="img"
                          src="/icons/selectIcon.svg"
                          sx={{ width: 24, height: 24 }}
                        />
                      )}
                      inputProps={{ "aria-label": "Select Category" }}
                    >
                      <MenuItem value="" disabled>
                        <em>Select Category</em> {/* Placeholder text */}
                      </MenuItem>
                      <MenuItem value={10}>Ten</MenuItem>
                      <MenuItem value={20}>Twenty</MenuItem>
                      <MenuItem value={30}>Thirty</MenuItem>
                    </Select>
                  </FormControl>
                  <Button
                    variant="contained"
                    sx={{
                      borderRadius: "6px",
                      px: "32px",
                      minWidth: "auto",
                      width: "auto",
                      textTransform: "none",
                      bgcolor: "#000000",
                      color: "#FFFFFF",
                      boxShadow: "none",
                      py: "14px",
                      borderRadius: "38px",
                    }}
                  >
                    Search
                  </Button>
                </Stack>
              </InputAdornment>
            ),
          }}
        />
        <Typography
          variant="body2"
          sx={{
            fontWeight: "700",
            fontSize: "14px",
            lineHeight: "22px",
            fontFamily: "Inter",
            color: darkMode ? "#ffffff" : "#0E0B33",
          }}
        >
          Popular Search:
        </Typography>
        <Stack direction="row" sx={{ gap: "10px", pt: "10px" }}>
          {popularSearchButtons.map((btn) => (
            <Button
              variant="contained"
              sx={{
                borderRadius: "50px",
                //   px: "26px",
                minWidth: "auto",
                width: "auto",
                textTransform: "none",
                bgcolor: darkMode ? "transparent" : "#ffffff",
                color: darkMode ? "#ffffff" : "#0E0B33",
                boxShadow: "none",
                //   py: "14px",
                border: darkMode ? ".5px solid #ffffff" : ".5px solid #0E0B33",
                fontWeight: "400",
                fontSize: "12px",
                lineHeight: "22px",
                zIndex: 1,
                "&:hover": {
                  backgroundColor: "transparent",
                  boxShadow: "none",
                },
                "&:active": {
                  backgroundColor: "transparent",
                  boxShadow: "none",
                },
                "&:focus": {
                  outline: "none",
                  boxshadow: "none",
                },
                "& .MuiButtonBase-root": {
                  width: "auto !important",
                  minWidth: "0px !important",
                  padding: "0px",
                  boxshadow: "none",
                },
              }}
            >
              {btn.text}
            </Button>
          ))}
        </Stack>
      </Stack>
      <Stack
        sx={{
          backgroundImage: `url(/images/empower.jpg)`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "430px",
          height: "460px",
          borderRadius: "50px",
          alignSelf: "end",
          position: "absolute",
          right: "0",
          zIndex: 0,
          mr: "80px",
        }}
      >
        <Stack
          sx={{
            bgcolor: "#FFFFFF",
            position: "absolute",
            p: "20px",
            py: "18px",
            borderRadius: "20px",
            boxShadow: "5px 10px 30px 0px #0000000D",
            left: -110,
            top: 130,
          }}
        >
          <Box
            component="img"
            src="/icons/CheckIconAvatar.svg"
            sx={{ width: "40px", height: "40px", mb: "6px" }}
          ></Box>
          <Typography
            variant="body2"
            sx={{
              fontWeight: "500",
              fontSize: "16px",
              lineHeight: "22px",
              fontFamily: "Inter",
              color: "#000000",
              width: "172px",
            }}
          >
            Your application is being reviewed!
          </Typography>
        </Stack>
        <Box
          component="img"
          src="/icons/jobBoardAddIcon.svg"
          sx={{
            width: 40,
            height: 40,
            position: "absolute",
            left: 70,
            top: 35,
          }}
        ></Box>
        <Stack
          id="Marketing-Genius"
          sx={{
            bgcolor: "#FFFFFF",
            position: "absolute",
            p: "20px",
            borderRadius: "20px",
            boxShadow: "5px 10px 30px 0px #0000000D",
            right: -100,
            top: -60,
          }}
        >
          <Stack direction="row" sx={{ alignItems: "center", gap: "12px" }}>
            {" "}
            <Box
              component="img"
              src="/images/marketingGenius.jpg"
              sx={{
                width: "48px",
                height: "48px",

                objectFit: "cover",
                borderRadius: "10px",
                display: "block",
              }}
            ></Box>
            <Typography
              variant="body2"
              sx={{
                fontWeight: "400",
                fontSize: "14px",
                lineHeight: "20px",
                fontFamily: "Inter",
                color: "#878599",
                width: "90px",
              }}
            >
              Marketing Genius Co.
            </Typography>
          </Stack>
          <MarketingGeniusButton>Apply Now</MarketingGeniusButton>
        </Stack>
        <Box
          component="img"
          src="/icons/jobBoardAddIcon.svg"
          sx={{
            width: 40,
            height: 40,
            position: "absolute",
            right: -90,
            bottom: 150,
          }}
        ></Box>
        <Stack
          id="acme-corporation"
          sx={{
            bgcolor: "#FFFFFF",
            position: "absolute",
            py: "22px",
            px: "24px",
            borderRadius: "20px",
            boxShadow: "5px 10px 30px 0px #0000000D",
            right: -70,
            bottom: -70,
          }}
        >
          <Stack direction="row" sx={{ gap: "60px" }}>
            {" "}
            <Stack direction="row" sx={{ alignItems: "center", gap: "12px" }}>
              {" "}
              <Box
                component="img"
                src="/images/acme.jpg"
                sx={{
                  width: "48px",
                  height: "48px",
                  objectFit: "cover",
                  borderRadius: "10px",
                  display: "block",
                }}
              ></Box>
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "400",
                  fontSize: "14px",
                  lineHeight: "20px",
                  fontFamily: "Inter",
                  color: "#878599",
                  width: "90px",
                }}
              >
                Acme Corporation
              </Typography>
            </Stack>
            <Typography
              variant="body2"
              sx={{
                fontWeight: "400",
                fontSize: "16px",
                lineHeight: "26px",
                fontFamily: "Inter",
                color: "#4a4866",
                // width: "90px",
              }}
            >
              Feb 15
            </Typography>
          </Stack>
          <Typography
            variant="body2"
            sx={{
              fontWeight: "700",
              fontSize: "26px",
              lineHeight: "20px",
              fontFamily: "Inter",
              color: "#0E0B33",
              pt: "20px",
            }}
          >
            UI/UX Designer
          </Typography>
          <MarketingGeniusButton alignSelf="start">
            Full Time
          </MarketingGeniusButton>
        </Stack>
      </Stack>
    </Stack>
  );
}

export default EmpowerYourCareerSection;
